import Kaiho from './Kaiho'

export default Kaiho
